import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const AutoLogout = ({ children }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const INACTIVITY_LIMIT = 20 * 60 * 1000;
  const timeoutRef = React.useRef(null);

  const logoutUser = useCallback(() => {

    logout();
    
    navigate("/login");
  }, [logout, navigate]);

  
  const resetTimer = useCallback(() => {
    
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    
    timeoutRef.current = setTimeout(() => {
      logoutUser();
    }, INACTIVITY_LIMIT);
  }, [logoutUser]);

  
  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];

    
    for (const event of events) {
      window.addEventListener(event, resetTimer);
    }

    
    resetTimer();

    
    return () => {
      for (const event of events) {
        window.removeEventListener(event, resetTimer);
      }
      if (timeoutRef) clearTimeout(timeoutRef.current);
    };
  }, [resetTimer]);

  return <>{children}</>;
};
AutoLogout.propTypes = {
  children: PropTypes.node
};

export default AutoLogout;